// Compuerta de arranque: el router NO debe decidir isAuthenticated hasta que `boot()` (main.js)
// haya intentado rehidratar la sesión desde la cookie. Sin esto, la navegación inicial del router
// corre ANTES del `getSession` async de boot y, en la primera visita al dashboard (llegada desde el
// registro, con localStorage vacío), el guard ve el store vacío y manda al login aunque la sesión
// exista. El primer beforeEach del router hace `await bootReady`.
let resolveBootReady;
export const bootReady = new Promise((resolve) => { resolveBootReady = resolve; });
export function markBootReady() {
    if (resolveBootReady) resolveBootReady();
}
export default { bootReady, markBootReady };
